import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Deployment = lazy(() => import('../../container/deployment/Deployment'));
const Widget = lazy(() => import('../../container/deployment/Widget'));
const GoogleSheets = lazy(() => import('../../container/deployment/GoogleSheets'));

function DeploymentRoutes() {
  const { path } = useRouteMatch();
  
  return (
    <Switch>
      <Route path={`${path}/domain`} component={Deployment} />
      <Route path={`${path}/widget`} component={Widget} />
      <Route path={`${path}/google-sheets`} component={GoogleSheets} />
    </Switch>
  );
}

export default DeploymentRoutes;
